export const hideInitialLoader = () => {
  const loader =
    document.getElementById('initial-loader') ||
    document.getElementById('mobile-initial-loader');
  if (!loader) return;

  const stylesheets = Array.from(
    document.querySelectorAll('link[data-vite-stylesheet]')
  );

  const stylesheetPromises = stylesheets.map(stylesheet => {
    if (stylesheet.dataset.loaded === 'true') return Promise.resolve();

    return new Promise(resolve => {
      stylesheet.addEventListener('load', resolve, { once: true });
      stylesheet.addEventListener('error', resolve, { once: true });
    });
  });

  Promise.all(stylesheetPromises).then(() => {
    window.requestAnimationFrame(() => {
      loader.dispatchEvent(new Event('initial-loader:hide'));
      if (loader.id === 'mobile-initial-loader') {
        loader.remove();
        return;
      }
      loader.classList.add('initial-loader--hidden');
      window.setTimeout(() => loader.remove(), 300);
    });
  });
};
